import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

import { twMerge } from "tailwind-merge";

import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";

import FontAwesomeIcon from "components/FontAwesomeIcon";
import useMediaQuery from "hooks/useMediaQuery";

type CircleButtonProps = {
  children?: React.ReactNode;
  className?: string;
  icon?: IconDefinition;
  tooltip?: string;
  disabled?: boolean;
  isProcessing?: boolean;
  onClick?: () => void;
};

const CircleButton = ({
  children,
  className,
  icon,
  tooltip,
  disabled,
  isProcessing,
  onClick,
}: CircleButtonProps) => {
  const { mobile } = useMediaQuery();

  return (
    <OverlayTrigger
      placement="left"
      overlay={tooltip && !mobile ? <Tooltip>{tooltip}</Tooltip> : <></>}
    >
      <div
        className={twMerge(
          "shadow bg-white rounded-full w-[44px] h-[44px] flex items-center justify-center mb-[10px] cursor-pointer",
          className
        )}
        onClick={() => !disabled && onClick?.()}
      >
        {icon && (
          <div
            className={twMerge(
              disabled || isProcessing ? "opacity-50" : "",
              isProcessing ? "cursor-wait" : ""
            )}
          >
            <FontAwesomeIcon icon={icon} />
          </div>
        )}
        <div
          className={twMerge(
            disabled || isProcessing ? "opacity-50" : "",
            isProcessing ? "cursor-wait" : ""
          )}
        >
          {children}
        </div>
      </div>
    </OverlayTrigger>
  );
};

export default CircleButton;
